// Lightweight country list for registration
// Manual city input to keep bundle size minimal

export const getAllCountries = () => {
    return [
        { isoCode: 'AF', name: 'Afghanistan', phonecode: '93' },
        { isoCode: 'AL', name: 'Albania', phonecode: '355' },
        { isoCode: 'DZ', name: 'Algeria', phonecode: '213' },
        { isoCode: 'AD', name: 'Andorra', phonecode: '376' },
        { isoCode: 'AO', name: 'Angola', phonecode: '244' },
        { isoCode: 'AR', name: 'Argentina', phonecode: '54' },
        { isoCode: 'AM', name: 'Armenia', phonecode: '374' },
        { isoCode: 'AU', name: 'Australia', phonecode: '61' },
        { isoCode: 'AT', name: 'Austria', phonecode: '43' },
        { isoCode: 'AZ', name: 'Azerbaijan', phonecode: '994' },
        { isoCode: 'BH', name: 'Bahrain', phonecode: '973' },
        { isoCode: 'BD', name: 'Bangladesh', phonecode: '880' },
        { isoCode: 'BY', name: 'Belarus', phonecode: '375' },
        { isoCode: 'BE', name: 'Belgium', phonecode: '32' },
        { isoCode: 'BZ', name: 'Belize', phonecode: '501' },
        { isoCode: 'BJ', name: 'Benin', phonecode: '229' },
        { isoCode: 'BT', name: 'Bhutan', phonecode: '975' },
        { isoCode: 'BO', name: 'Bolivia', phonecode: '591' },
        { isoCode: 'BA', name: 'Bosnia and Herzegovina', phonecode: '387' },
        { isoCode: 'BW', name: 'Botswana', phonecode: '267' },
        { isoCode: 'BR', name: 'Brazil', phonecode: '55' },
        { isoCode: 'BN', name: 'Brunei', phonecode: '673' },
        { isoCode: 'BG', name: 'Bulgaria', phonecode: '359' },
        { isoCode: 'BF', name: 'Burkina Faso', phonecode: '226' },
        { isoCode: 'BI', name: 'Burundi', phonecode: '257' },
        { isoCode: 'KH', name: 'Cambodia', phonecode: '855' },
        { isoCode: 'CM', name: 'Cameroon', phonecode: '237' },
        { isoCode: 'CA', name: 'Canada', phonecode: '1' },
        { isoCode: 'CV', name: 'Cape Verde', phonecode: '238' },
        { isoCode: 'CF', name: 'Central African Republic', phonecode: '236' },
        { isoCode: 'TD', name: 'Chad', phonecode: '235' },
        { isoCode: 'CL', name: 'Chile', phonecode: '56' },
        { isoCode: 'CN', name: 'China', phonecode: '86' },
        { isoCode: 'CO', name: 'Colombia', phonecode: '57' },
        { isoCode: 'KM', name: 'Comoros', phonecode: '269' },
        { isoCode: 'CG', name: 'Congo', phonecode: '242' },
        { isoCode: 'CR', name: 'Costa Rica', phonecode: '506' },
        { isoCode: 'HR', name: 'Croatia', phonecode: '385' },
        { isoCode: 'CU', name: 'Cuba', phonecode: '53' },
        { isoCode: 'CY', name: 'Cyprus', phonecode: '357' },
        { isoCode: 'CZ', name: 'Czech Republic', phonecode: '420' },
        { isoCode: 'DK', name: 'Denmark', phonecode: '45' },
        { isoCode: 'DJ', name: 'Djibouti', phonecode: '253' },
        { isoCode: 'DO', name: 'Dominican Republic', phonecode: '1-809' },
        { isoCode: 'EC', name: 'Ecuador', phonecode: '593' },
        { isoCode: 'EG', name: 'Egypt', phonecode: '20' },
        { isoCode: 'SV', name: 'El Salvador', phonecode: '503' },
        { isoCode: 'GQ', name: 'Equatorial Guinea', phonecode: '240' },
        { isoCode: 'ER', name: 'Eritrea', phonecode: '291' },
        { isoCode: 'EE', name: 'Estonia', phonecode: '372' },
        { isoCode: 'ET', name: 'Ethiopia', phonecode: '251' },
        { isoCode: 'FJ', name: 'Fiji', phonecode: '679' },
        { isoCode: 'FI', name: 'Finland', phonecode: '358' },
        { isoCode: 'FR', name: 'France', phonecode: '33' },
        { isoCode: 'GA', name: 'Gabon', phonecode: '241' },
        { isoCode: 'GM', name: 'Gambia', phonecode: '220' },
        { isoCode: 'GE', name: 'Georgia', phonecode: '995' },
        { isoCode: 'DE', name: 'Germany', phonecode: '49' },
        { isoCode: 'GH', name: 'Ghana', phonecode: '233' },
        { isoCode: 'GR', name: 'Greece', phonecode: '30' },
        { isoCode: 'GT', name: 'Guatemala', phonecode: '502' },
        { isoCode: 'GN', name: 'Guinea', phonecode: '224' },
        { isoCode: 'GW', name: 'Guinea-Bissau', phonecode: '245' },
        { isoCode: 'GY', name: 'Guyana', phonecode: '592' },
        { isoCode: 'HT', name: 'Haiti', phonecode: '509' },
        { isoCode: 'HN', name: 'Honduras', phonecode: '504' },
        { isoCode: 'HU', name: 'Hungary', phonecode: '36' },
        { isoCode: 'IS', name: 'Iceland', phonecode: '354' },
        { isoCode: 'IN', name: 'India', phonecode: '91' },
        { isoCode: 'ID', name: 'Indonesia', phonecode: '62' },
        { isoCode: 'IR', name: 'Iran', phonecode: '98' },
        { isoCode: 'IQ', name: 'Iraq', phonecode: '964' },
        { isoCode: 'IE', name: 'Ireland', phonecode: '353' },
        { isoCode: 'IL', name: 'Israel', phonecode: '972' },
        { isoCode: 'IT', name: 'Italy', phonecode: '39' },
        { isoCode: 'JM', name: 'Jamaica', phonecode: '1-876' },
        { isoCode: 'JP', name: 'Japan', phonecode: '81' },
        { isoCode: 'JO', name: 'Jordan', phonecode: '962' },
        { isoCode: 'KZ', name: 'Kazakhstan', phonecode: '7' },
        { isoCode: 'KE', name: 'Kenya', phonecode: '254' },
        { isoCode: 'KW', name: 'Kuwait', phonecode: '965' },
        { isoCode: 'KG', name: 'Kyrgyzstan', phonecode: '996' },
        { isoCode: 'LA', name: 'Laos', phonecode: '856' },
        { isoCode: 'LV', name: 'Latvia', phonecode: '371' },
        { isoCode: 'LB', name: 'Lebanon', phonecode: '961' },
        { isoCode: 'LS', name: 'Lesotho', phonecode: '266' },
        { isoCode: 'LR', name: 'Liberia', phonecode: '231' },
        { isoCode: 'LY', name: 'Libya', phonecode: '218' },
        { isoCode: 'LT', name: 'Lithuania', phonecode: '370' },
        { isoCode: 'LU', name: 'Luxembourg', phonecode: '352' },
        { isoCode: 'MG', name: 'Madagascar', phonecode: '261' },
        { isoCode: 'MW', name: 'Malawi', phonecode: '265' },
        { isoCode: 'MY', name: 'Malaysia', phonecode: '60' },
        { isoCode: 'MV', name: 'Maldives', phonecode: '960' },
        { isoCode: 'ML', name: 'Mali', phonecode: '223' },
        { isoCode: 'MT', name: 'Malta', phonecode: '356' },
        { isoCode: 'MR', name: 'Mauritania', phonecode: '222' },
        { isoCode: 'MU', name: 'Mauritius', phonecode: '230' },
        { isoCode: 'MX', name: 'Mexico', phonecode: '52' },
        { isoCode: 'MD', name: 'Moldova', phonecode: '373' },
        { isoCode: 'MC', name: 'Monaco', phonecode: '377' },
        { isoCode: 'MN', name: 'Mongolia', phonecode: '976' },
        { isoCode: 'ME', name: 'Montenegro', phonecode: '382' },
        { isoCode: 'MA', name: 'Morocco', phonecode: '212' },
        { isoCode: 'MZ', name: 'Mozambique', phonecode: '258' },
        { isoCode: 'MM', name: 'Myanmar', phonecode: '95' },
        { isoCode: 'NA', name: 'Namibia', phonecode: '264' },
        { isoCode: 'NP', name: 'Nepal', phonecode: '977' },
        { isoCode: 'NL', name: 'Netherlands', phonecode: '31' },
        { isoCode: 'NZ', name: 'New Zealand', phonecode: '64' },
        { isoCode: 'NI', name: 'Nicaragua', phonecode: '505' },
        { isoCode: 'NE', name: 'Niger', phonecode: '227' },
        { isoCode: 'NG', name: 'Nigeria', phonecode: '234' },
        { isoCode: 'KP', name: 'North Korea', phonecode: '850' },
        { isoCode: 'MK', name: 'North Macedonia', phonecode: '389' },
        { isoCode: 'NO', name: 'Norway', phonecode: '47' },
        { isoCode: 'OM', name: 'Oman', phonecode: '968' },
        { isoCode: 'PK', name: 'Pakistan', phonecode: '92' },
        { isoCode: 'PS', name: 'Palestine', phonecode: '970' },
        { isoCode: 'PA', name: 'Panama', phonecode: '507' },
        { isoCode: 'PG', name: 'Papua New Guinea', phonecode: '675' },
        { isoCode: 'PY', name: 'Paraguay', phonecode: '595' },
        { isoCode: 'PE', name: 'Peru', phonecode: '51' },
        { isoCode: 'PH', name: 'Philippines', phonecode: '63' },
        { isoCode: 'PL', name: 'Poland', phonecode: '48' },
        { isoCode: 'PT', name: 'Portugal', phonecode: '351' },
        { isoCode: 'QA', name: 'Qatar', phonecode: '974' },
        { isoCode: 'RO', name: 'Romania', phonecode: '40' },
        { isoCode: 'RU', name: 'Russia', phonecode: '7' },
        { isoCode: 'RW', name: 'Rwanda', phonecode: '250' },
        { isoCode: 'SA', name: 'Saudi Arabia', phonecode: '966' },
        { isoCode: 'SN', name: 'Senegal', phonecode: '221' },
        { isoCode: 'RS', name: 'Serbia', phonecode: '381' },
        { isoCode: 'SC', name: 'Seychelles', phonecode: '248' },
        { isoCode: 'SL', name: 'Sierra Leone', phonecode: '232' },
        { isoCode: 'SG', name: 'Singapore', phonecode: '65' },
        { isoCode: 'SK', name: 'Slovakia', phonecode: '421' },
        { isoCode: 'SI', name: 'Slovenia', phonecode: '386' },
        { isoCode: 'SO', name: 'Somalia', phonecode: '252' },
        { isoCode: 'ZA', name: 'South Africa', phonecode: '27' },
        { isoCode: 'KR', name: 'South Korea', phonecode: '82' },
        { isoCode: 'SS', name: 'South Sudan', phonecode: '211' },
        { isoCode: 'ES', name: 'Spain', phonecode: '34' },
        { isoCode: 'LK', name: 'Sri Lanka', phonecode: '94' },
        { isoCode: 'SD', name: 'Sudan', phonecode: '249' },
        { isoCode: 'SR', name: 'Suriname', phonecode: '597' },
        { isoCode: 'SE', name: 'Sweden', phonecode: '46' },
        { isoCode: 'CH', name: 'Switzerland', phonecode: '41' },
        { isoCode: 'SY', name: 'Syria', phonecode: '963' },
        { isoCode: 'TW', name: 'Taiwan', phonecode: '886' },
        { isoCode: 'TJ', name: 'Tajikistan', phonecode: '992' },
        { isoCode: 'TZ', name: 'Tanzania', phonecode: '255' },
        { isoCode: 'TH', name: 'Thailand', phonecode: '66' },
        { isoCode: 'TG', name: 'Togo', phonecode: '228' },
        { isoCode: 'TT', name: 'Trinidad and Tobago', phonecode: '1-868' },
        { isoCode: 'TN', name: 'Tunisia', phonecode: '216' },
        { isoCode: 'TR', name: 'Turkey', phonecode: '90' },
        { isoCode: 'TM', name: 'Turkmenistan', phonecode: '993' },
        { isoCode: 'UG', name: 'Uganda', phonecode: '256' },
        { isoCode: 'UA', name: 'Ukraine', phonecode: '380' },
        { isoCode: 'AE', name: 'United Arab Emirates', phonecode: '971' },
        { isoCode: 'GB', name: 'United Kingdom', phonecode: '44' },
        { isoCode: 'US', name: 'United States', phonecode: '1' },
        { isoCode: 'UY', name: 'Uruguay', phonecode: '598' },
        { isoCode: 'UZ', name: 'Uzbekistan', phonecode: '998' },
        { isoCode: 'VU', name: 'Vanuatu', phonecode: '678' },
        { isoCode: 'VE', name: 'Venezuela', phonecode: '58' },
        { isoCode: 'VN', name: 'Vietnam', phonecode: '84' },
        { isoCode: 'YE', name: 'Yemen', phonecode: '967' },
        { isoCode: 'ZM', name: 'Zambia', phonecode: '260' },
        { isoCode: 'ZW', name: 'Zimbabwe', phonecode: '263' },
    ].sort((a, b) => a.name.localeCompare(b.name));
};

export const getCitiesOfCountry = (countryCode) => {
    // City data not included to keep bundle lightweight
    // Users can manually type their city using CreatableSelect
    return [];
};
